// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#afis-app .list-horizontal-bars {
  list-style-type: none;
  padding: 0;
}
#afis-app .list-horizontal-bars li {
  border-bottom: 1px solid #ccc;
  line-height: 22px;
  width: 100%;
  margin-bottom: 0;
  display: flex;
}
#afis-app .list-horizontal-bars li .label-container-blue-bar {
  flex-grow: 1;
}
#afis-app .list-horizontal-bars li .label-container-blue-bar .label-value-blue-bar {
  position: relative;
  z-index: 1;
  font-family: "AvenirNextLTW01-Regular", Arial;
  font-size: 14px;
  text-align: left;
  line-height: 22px;
  color: #333333;
  margin-bottom: 1px;
  padding-left: 10px;
}
#afis-app .list-horizontal-bars li .label-container-blue-bar .label-value-blue-bar .blue-bar {
  position: absolute;
  top: 1px;
  left: 0;
  height: 100%;
  background-color: #f2fcff;
  font-family: 'AvenirNextLTW01-Regular', Arial, serif;
}
#afis-app .list-horizontal-bars li .data-value {
  padding-right: 8px;
  padding-left: 8px;
  color: #333333;
  font-family: "Avenir Next LT W01 Demi", Arial;
  font-size: 14px;
  line-height: 22px;
}
#afis-app .list-horizontal-bars .top-border {
  border-top: 1px solid #ccc;
}
#afis-app .list-label-value {
  list-style-type: none;
  padding: 0;
  width: 100%;
}
#afis-app .list-label-value li {
  border-bottom: 1px solid #ccc;
  line-height: 22px;
  width: 100%;
  margin-bottom: 0;
  display: flex;
  flex-wrap: wrap;
}
#afis-app .list-label-value li.top-border {
  border-top: 1px solid #ccc;
}
#afis-app .list-label-value li.no-line {
  border-bottom: 1px solid rgba(0, 0, 0, 0);
}
#afis-app .list-label-value li .list-label {
  flex-grow: 1;
  font-family: AvenirNextLTW01-Regular, Arial, sans-serif;
  font-size: 14px;
  text-align: left;
  line-height: 24px;
  color: #333333;
  padding-left: 8px;
}
#afis-app .list-label-value li .list-label.strong {
  font-family: "Avenir Next LT W01 Demi", Arial, sans-serif;
}
#afis-app .list-label-value li .list-label.nested-label {
  line-height: 18px;
  margin-left: 20px;
}
#afis-app .list-label-value li .list-value {
  padding-right: 8px;
  padding-left: 8px;
  color: #333333;
  font-family: AvenirNextLTW01-Regular, Arial, sans-serif;
  font-size: 14px;
  line-height: 22px;
}
#afis-app .list-label-value li .list-value.strong {
  font-family: "Avenir Next LT W01 Demi", Arial, sans-serif;
}
#afis-app .list-label-value li .list-value.nested-value {
  line-height: 18px;
}
#afis-app .chart-legend-container {
  display: flex;
  margin-bottom: 20px;
}
#afis-app .chart-legend-container img {
  margin: auto;
  margin-left: 0;
  margin-right: 15%;
}
#afis-app .chart-legend-container .legend-container {
  display: inline-block;
  width: 40%;
  margin-right: 40px;
}
#afis-app .chart-legend-container .legend-container .chart-legend {
  list-style-type: none;
  padding: 0;
}
#afis-app .chart-legend-container .legend-container .chart-legend li {
  border-bottom: 1px solid #cccccc;
  line-height: 22px;
  width: 100%;
  margin-bottom: 0;
  display: flex;
}
#afis-app .chart-legend-container .legend-container .chart-legend li.no-border {
  border: none;
}
#afis-app .chart-legend-container .legend-container .chart-legend li .chart-label {
  flex-grow: 1;
  font-family: "AvenirNextLTW01-Regular", serif;
  font-size: 12px;
  text-align: left;
  line-height: 26px;
  color: #666;
  position: relative;
}
#afis-app .chart-legend-container .legend-container .chart-legend li .chart-label .color-square {
  position: absolute;
  height: 10px;
  width: 10px;
  left: -20px;
  top: 8px;
}
#afis-app .chart-legend-container .legend-container .chart-legend li .chart-value {
  padding-left: 8px;
  color: #333;
  font-family: "Avenir Next LT W01 Demi", Arial, serif;
  font-size: 12px;
  line-height: 26px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/list.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,6CAA6C;EAC7C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,yBAAyB;EACzB,oDAAoD;AACtD;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,6CAA6C;EAC7C,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;AACb;AACA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,YAAY;EACZ,uDAAuD;EACvD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,yDAAyD;AAC3D;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,uDAAuD;EACvD,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,yDAAyD;AAC3D;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,6CAA6C;EAC7C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,oDAAoD;EACpD,eAAe;EACf,iBAAiB;AACnB","sourcesContent":["#afis-app .list-horizontal-bars {\n  list-style-type: none;\n  padding: 0;\n}\n#afis-app .list-horizontal-bars li {\n  border-bottom: 1px solid #ccc;\n  line-height: 22px;\n  width: 100%;\n  margin-bottom: 0;\n  display: flex;\n}\n#afis-app .list-horizontal-bars li .label-container-blue-bar {\n  flex-grow: 1;\n}\n#afis-app .list-horizontal-bars li .label-container-blue-bar .label-value-blue-bar {\n  position: relative;\n  z-index: 1;\n  font-family: \"AvenirNextLTW01-Regular\", Arial;\n  font-size: 14px;\n  text-align: left;\n  line-height: 22px;\n  color: #333333;\n  margin-bottom: 1px;\n  padding-left: 10px;\n}\n#afis-app .list-horizontal-bars li .label-container-blue-bar .label-value-blue-bar .blue-bar {\n  position: absolute;\n  top: 1px;\n  left: 0;\n  height: 100%;\n  background-color: #f2fcff;\n  font-family: 'AvenirNextLTW01-Regular', Arial, serif;\n}\n#afis-app .list-horizontal-bars li .data-value {\n  padding-right: 8px;\n  padding-left: 8px;\n  color: #333333;\n  font-family: \"Avenir Next LT W01 Demi\", Arial;\n  font-size: 14px;\n  line-height: 22px;\n}\n#afis-app .list-horizontal-bars .top-border {\n  border-top: 1px solid #ccc;\n}\n#afis-app .list-label-value {\n  list-style-type: none;\n  padding: 0;\n  width: 100%;\n}\n#afis-app .list-label-value li {\n  border-bottom: 1px solid #ccc;\n  line-height: 22px;\n  width: 100%;\n  margin-bottom: 0;\n  display: flex;\n  flex-wrap: wrap;\n}\n#afis-app .list-label-value li.top-border {\n  border-top: 1px solid #ccc;\n}\n#afis-app .list-label-value li.no-line {\n  border-bottom: 1px solid rgba(0, 0, 0, 0);\n}\n#afis-app .list-label-value li .list-label {\n  flex-grow: 1;\n  font-family: AvenirNextLTW01-Regular, Arial, sans-serif;\n  font-size: 14px;\n  text-align: left;\n  line-height: 24px;\n  color: #333333;\n  padding-left: 8px;\n}\n#afis-app .list-label-value li .list-label.strong {\n  font-family: \"Avenir Next LT W01 Demi\", Arial, sans-serif;\n}\n#afis-app .list-label-value li .list-label.nested-label {\n  line-height: 18px;\n  margin-left: 20px;\n}\n#afis-app .list-label-value li .list-value {\n  padding-right: 8px;\n  padding-left: 8px;\n  color: #333333;\n  font-family: AvenirNextLTW01-Regular, Arial, sans-serif;\n  font-size: 14px;\n  line-height: 22px;\n}\n#afis-app .list-label-value li .list-value.strong {\n  font-family: \"Avenir Next LT W01 Demi\", Arial, sans-serif;\n}\n#afis-app .list-label-value li .list-value.nested-value {\n  line-height: 18px;\n}\n#afis-app .chart-legend-container {\n  display: flex;\n  margin-bottom: 20px;\n}\n#afis-app .chart-legend-container img {\n  margin: auto;\n  margin-left: 0;\n  margin-right: 15%;\n}\n#afis-app .chart-legend-container .legend-container {\n  display: inline-block;\n  width: 40%;\n  margin-right: 40px;\n}\n#afis-app .chart-legend-container .legend-container .chart-legend {\n  list-style-type: none;\n  padding: 0;\n}\n#afis-app .chart-legend-container .legend-container .chart-legend li {\n  border-bottom: 1px solid #cccccc;\n  line-height: 22px;\n  width: 100%;\n  margin-bottom: 0;\n  display: flex;\n}\n#afis-app .chart-legend-container .legend-container .chart-legend li.no-border {\n  border: none;\n}\n#afis-app .chart-legend-container .legend-container .chart-legend li .chart-label {\n  flex-grow: 1;\n  font-family: \"AvenirNextLTW01-Regular\", serif;\n  font-size: 12px;\n  text-align: left;\n  line-height: 26px;\n  color: #666;\n  position: relative;\n}\n#afis-app .chart-legend-container .legend-container .chart-legend li .chart-label .color-square {\n  position: absolute;\n  height: 10px;\n  width: 10px;\n  left: -20px;\n  top: 8px;\n}\n#afis-app .chart-legend-container .legend-container .chart-legend li .chart-value {\n  padding-left: 8px;\n  color: #333;\n  font-family: \"Avenir Next LT W01 Demi\", Arial, serif;\n  font-size: 12px;\n  line-height: 26px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
